
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.5 3a.5.5 0 01.5-.5h14a.5.5 0 01.5.5v14a.5.5 0 01-.5.5H3a.5.5 0 01-.5-.5V3zm9 7.317l2.931-2.76a.75.75 0 000-1.092L11.5 3.705a.75.75 0 00-1.264.545v1.26H7.188a1.5 1.5 0 000 3h3.047v1.26a.75.75 0 001.264.547zM5.73 13.54L8.6 16.294a.75.75 0 001.27-.542V14.5h2.978a1.5 1.5 0 000-3H9.868v-1.252a.75.75 0 00-1.27-.542L5.732 12.46a.75.75 0 000 1.082z","fill":"currentColor","stroke":"currentColor"}})])
          )
        }
      }
    